import { atom } from "jotai";
import type { StreamServerSettings } from "../infrastructure/Repositories/Stream/BaseStreamRepository.interface";

export type StreamConfigurations = Record<string, StreamServerSettings>;

export const atomStreamConfigurations = atom<StreamConfigurations>({
  twitch: {
    streamUrl: "rtmp://ingest.global-contribute.live-video.net/app",
    streamKey: "",
    enabled: false,
    integrated: false,
    config: {
      name: "Twitch",
    },
  },
  livepeer: {
    streamUrl: "",
    streamKey: "",
    enabled: false,
    integrated: false,
    config: {
      name: "LivePeer",
    },
  },
  youtube: {
    streamUrl: "rtmp://a.rtmp.youtube.com/live2/",
    streamKey: "",
    enabled: false,
    integrated: false,
    config: {
      name: "Youtube",
    },
  },
  kick: {
    streamUrl: "rtmp://ingest.kick.com/live",
    streamKey: "",
    enabled: false,
    integrated: false,
    config: {
      name: "Kick",
    },
  },
  restream: {
    streamUrl: "rtmp://live.restream.io/live",
    streamKey: "",
    enabled: false,
    integrated: false,
    config: {
      name: "Restream",
    },
  },
});
